import Link, { LinkProps } from 'next/link'
import { forwardRef, HTMLAttributeAnchorTarget, HTMLAttributes } from 'react'
import { DEFAULT_LOCALE } from '@/constants/defaultLocale.constant'

type LocalizedLinkProps = Omit<LinkProps, 'hrefLang' | 'locale'> &
	Omit<HTMLAttributes<HTMLAnchorElement>, 'href' | 'contentEditable'> & {
		locale?: string | string[]
		target?: HTMLAttributeAnchorTarget | undefined
	} & { href: LinkProps['href'] | undefined }

export const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(
	(
		{ locale = DEFAULT_LOCALE, children, href, lang, className, ...rest },
		ref,
	) => {
		const _locale = Array.isArray(locale) ? locale[0] : locale

		if (!href) {
			return <span className={className}>{children}</span>
		}

		return (
			<Link
				locale={_locale}
				lang={lang ?? _locale}
				hrefLang={locale ? locale.toString() : 'x-default'}
				href={`/${_locale.toLowerCase().replace('_', '-')}${href}`}
				className={className}
				{...rest}
				ref={ref}
			>
				{children}
			</Link>
		)
	},
)

LocalizedLink.displayName = 'LocalizedLink'
